module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/rv1.webp";